module.exports = __webpack_public_path__ + "4e804df47bbc7fccc21428962ddf58a0.pdf";